import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer
      style={{
        marginTop: 'auto',
        flexShrink: 0,
        boxSizing: 'border-box',
        width: '100%',
        padding: '1.15em max(16px, env(safe-area-inset-left)) 1em max(16px, env(safe-area-inset-right))',
        background: 'rgba(10, 10, 10, 0.75)',
        borderTop: '1px solid rgba(255, 255, 255, 0.08)',
        backdropFilter: 'blur(8px)',
      }}
    >
      <div
        style={{
          textAlign: 'center',
          color: 'rgba(255, 255, 255, 0.72)',
          fontSize: '0.88em',
          maxWidth: '100%',
          margin: 0,
          padding: 0,
        }}
      >
        <div style={{ margin: '0 0 0.45em', padding: '0 8px', lineHeight: 1.4 }}>
          <strong style={{ color: '#fff', fontWeight: 600 }}>Gettel Telecomunicações</strong>
          {' '}
          — Sistema de Gestão Empresarial
        </div>
        <div
          style={{
            color: 'rgba(255, 255, 255, 0.5)',
            fontSize: '0.9em',
            lineHeight: 1.45,
            margin: 0,
            padding: '0 8px',
            wordBreak: 'break-word',
          }}
        >
          © {new Date().getFullYear()} — Direitos reservados a E.R. 2 GESTAO EM TELECOMUNICACOES LTDA
        </div>
        <div style={{ margin: '0.75em 0 0', padding: 0, lineHeight: 1 }}>
          <a
            href="https://www.siterastreio.com.br/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: 'rgba(0, 212, 170, 0.9)',
              fontSize: '0.92em',
              lineHeight: 1,
              textDecoration: 'underline',
              textDecorationColor: 'rgba(0, 212, 170, 0.45)',
              textUnderlineOffset: '3px',
            }}
          >
            Rastreamento
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
